__turbopack_context__.v({
  "grid": "ContainerGrid-module-scss-module__sk68LW__grid",
});
